<template>
  <nav class="mobile-menu" :class="mobileMenuOpen ? 'mobile-menu--show': ''">
    <nav class="mm-secondary-nav">
      <ul class="mm-secondary-nav__menu">
        <li class="mm-secondary-nav__menu-item">
          <a :href="helpLink" class="mm-secondary-nav__link">{{ $t('message.help') }}</a>
        </li>
        <span class="mm-secondary-nav__menu-language">
          <li class="mm-secondary-nav__menu-item" v-if="$i18n.locale != 'en'">
            <a href="/en" class="mm-secondary-nav__link" @click.prevent="updateLocale('en')">English</a>
          </li>
          <li class="mm-secondary-nav__menu-item" v-if="$i18n.locale != 'sc'">
            <a href="/sc" class="mm-secondary-nav__link" @click.prevent="updateLocale('sc')">简</a>
          </li>
          <li class="mm-secondary-nav__menu-item" v-if="$i18n.locale != 'tc'">
            <a href="/tc" class="mm-secondary-nav__link" @click.prevent="updateLocale('tc')">繁</a>
          </li>
        </span>
      </ul>
    </nav>
    <nav class="mega-menu-wrapper mobile-menu__mega-menu">
      <ul class="mega-menu mega-menu--depth-1">
        <mobile-menu-level-1 v-for="(item, index) in items"
          :item="item"
          :key="`mobile-1-${index}`"
          ref="mobileMenuLevel1"/>
      </ul>
    </nav>
  </nav>
</template>

<script>
import MobileMenuLevel1 from "@/components/layout/header/MobileMenu/MobileMenuLevel1"

export default {
  name: 'mobile-menu',
  components: {
    MobileMenuLevel1
  },
  props: ["items", "mobileMenuOpen"],
  methods: {
    updateLocale(value) {
      this.$emit('updateLocale', value)
    }
  },
  computed: {
    helpLink() {
      return process.env.VUE_APP_WK_FRONT_END_URL + '/' + this.$i18n.locale + '/help';
    }
  }
}
</script>